import React, { useEffect, useState } from 'react';
export function useCountdown(initialMinutes: number, initialSeconds: number) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isFinished: timeLeft <= 0
  };
}
export function CountdownDisplay({
  minutes,
  seconds,
  className = ''
}: {
  minutes: string;
  seconds: string;
  className?: string;
}) {
  return <div className={`flex items-center gap-1 font-heading font-bold ${className}`} data-id="element-23">
      <div className="bg-primary text-white rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-24">
        {minutes}
      </div>
      <span className="text-white" data-id="element-25">:</span>
      <div className="bg-primary text-white rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-26">
        {seconds}
      </div>
    </div>;
}